import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import './../../styles/sendmail.css';

function SendMail (){
const [status, setStatus] = useState(true)
const form = useRef();
const sendEmail = (e) => {
  e.preventDefault();
  emailjs
    .sendForm('service_07tdr1v', 'template_ztvnu9j', form.current,  {
        publicKey: 'yRiafbPoaajspI1eS',
      }
    )
    .then(
      () => {
        console.log('SUCCESS!');
      },
      (error) => {
        console.log('FAILED...', error.text, form);
      },
    );
    setStatus(false)
};

return (
    <>
      { status && (
        <form ref={form} onSubmit={sendEmail} id="form" classNames="topBefore">
            <input type="text" name="user_name" placeholder="Имя" />
            <input type="email" name="user_email" placeholder="Email" />
            <textarea name="message" placeholder="Сообщение" />
            <input id="submit" type="submit" value="Отправить"/>
        </form> 
      )
      }
      { !status && (
        <p style={{
            marginTop:'30px',
            color:'gray',
            fontSize: '20px',
            textAlign: 'center',
        }}>Сообщение отправлено</p>
      ) 

      }
    </>)}

export default SendMail;